import React from "react";
import { useSelector } from "react-redux";
import { Alert } from "reactstrap";
import { currentLocationSelector } from "../../store/locationStore/selectors";
import { showClosestFirstSelector } from "../../store/restaurantsStore/selectors";

export default () => {
  const currentLocation = useSelector(currentLocationSelector);
  const showClosestFirst = useSelector(showClosestFirstSelector);

  return showClosestFirst && currentLocation ? (
    <Alert
      color="info"
      style={{
        textAlign: "center",
        marginBottom: 0,
        fontSize: "2vh"
      }}
    >
      Closest Restaurant First
    </Alert>
  ) : (
    <></>
  );
};
